import request from "@/utils/request";

// 根据id查询详情
export function queryStationInfoByPlantId(plantId) {
  return request({
    url: `/opPlantsBaseInfo/getInfoByPlansId/${plantId}`,
    method: "get",
  });
}

// 新增
export function inertStationInfo(data) {
  return request({
    url: "/opPlantsBaseInfo/save",
    method: "post",
    data,
  });
}

// 修改
export function updateStationInfo(data) {
  return request({
    url: "/opPlantsBaseInfo/update",
    method: "post",
    data,
  });
}

// 新增或修改厂站基本信息
export function insertOrUpdateStationInfo(data) {
  return request({
    url: "/opPlantsBaseInfo/saveOrUpdatePlantsBaseInfo",
    method: "post",
    data,
  });
}
// 获取组织架构树
export function queryOrgTree(data) {
  return request({
    url: "/org/getOrgTee",
    method: "post",
    data,
  });
}

// 查询净水厂出水标准
export function queryEffluentStandard(data) {
  return request({
    url: "/opStandardWaterOutClean/page",
    method: "post",
    data,
  });
}

// 获取字典数据
export function queryDictData(type) {
  return request({
    url: `/dict/type?type=${type}`,
    method: "get",
  });
}

// 获取工艺流程图
export function queryFlowChart(plantId) {
  return request({
    url: `/opPlantsFlowChart/getFlowChartInfo/${plantId}`,
    method: "get",
  });
}

// 新增流程图
export function insertFlowChart(data) {
  return request({
    url: "/opPlantsFlowChart/save",
    method: "post",
    data,
  });
}

// 编辑流程图
export function updateFlowChart(data) {
  return request({
    url: "/opPlantsFlowChart/update",
    method: "post",
    data,
  });
}

// 获取摄像头
export function queryCameraByPlantId(data) {
  return request({
    url: "/opPlantsCamera/getPageByPlansId",
    method: "post",
    data,
  });
}

// 同步摄像头
export function syncCamera(plantId) {
  return request({
    url: `/opPlantsCamera/syncCamera/${plantId}`,
    method: "get",
  });
}

// 获取摄像头播放链接
export function queryCameraLink(id) {
  return request({
    url: `/opPlantsCamera/getConnectInfo/${id}`,
    method: "post",
  });
}

// 控制摄像头
export function controlCamera(params) {
  return request({
    url: "/opPlantsCamera/controlCamera",
    method: "get",
    params,
  });
}
